import { Box, Card, Stack, Typography, CardContent } from '@mui/material';

import { useTranslate } from 'src/locales';
import { PasswordField, ConnectionButton, ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

import { useWhatsappStep2 } from '../hooks';
import { SecurityWarningAlert } from './security-warning-alert';

type Step2Props = {
  isFaceBook?: boolean;
};

export function Step2({ isFaceBook = false }: Step2Props) {
  const { t } = useTranslate('translation');

  const { methods, channelName, isWhatsappConnectSuccess, isNextDisabled, connect, onSubmit } =
    useWhatsappStep2();

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout title="" subtitle="" isNextDisabled={isNextDisabled}>
          <Stack spacing={3}>
            {/* Channel Name Section */}
            <Box>
              <Field.Text
                name="channelName"
                label={t('CHANNEL_NAME')}
                InputLabelProps={{ shrink: true }}
                placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
                helperText={t('CHANNEL_NAME_HELPER')}
              />
            </Box>

            {/* Facebook Connection Section */}
            <Box>
              <ConnectionButton
                label={t('SIGN_IN_WITH_FACEBOOK')}
                icon="logos:facebook"
                onClick={connect}
                disabled={!channelName}
                isConnected={isWhatsappConnectSuccess}
                successMessage={t('ACCOUNT_VERIFIED')}
              />
            </Box>

            {/* 2FA PIN Section */}
            {isWhatsappConnectSuccess && (
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    {t('SECURITY_SETTINGS')}
                  </Typography>

                  <Box sx={{ mb: 3 }}>
                    <PasswordField
                      name="pin"
                      label={t('2FA_PIN')}
                      placeholder={t('SET_6_DIGIT_PIN')}
                      slotProps={{
                        input: {
                          inputProps: {
                            pattern: '[0-9]*',
                            inputMode: 'numeric',
                            maxLength: 6,
                          },
                        },
                      }}
                      helperText={t('PIN_HELP_TEXT')}
                    />
                  </Box>

                  <SecurityWarningAlert
                    title={t('IMPORTANT_SECURITY_NOTICE')}
                    warnings={[1, 2, 3, 4, 5].map((i) => t(`PIN_WARNING_${i}`))}
                  />

                  <Field.Checkbox name="pinAcknowledge" label={t('PIN_ACKNOWLEDGEMENT')} />
                </CardContent>
              </Card>
            )}
          </Stack>
        </ChannelStepLayout>
      </Form>
    </Stack>
  );
}
